import { useGetAccountGroupsOptions } from '../../../../../queries';
import { t } from 'i18next';
import { singleSelectValueFormatter } from 'components/shared/DataGrid/utils/valueFormatters/singleSelectValueFormatter';
import { dateFormatter } from 'components/shared/DataGrid/utils/valueFormatters/dateFormatter';
import { nestedFieldValueGetter } from 'utils/grid';
import { GridColDef } from '@mui/x-data-grid-pro';

export const useGetAccountGroupsColumns = () => {
  const { data: options } = useGetAccountGroupsOptions();

  return [
    {
      field: 'groupId',
      type: 'singleSelect',
      headerName: t('groupName'),
      valueOptions: options,
      valueFormatter: (params) =>
        singleSelectValueFormatter(params, options ?? []),
      flex: 2
    },
    {
      field: 'valid.from',
      type: 'date',
      headerName: t('validFrom'),
      valueGetter: (_, row) => nestedFieldValueGetter(row, 'valid.from'),
      valueFormatter: dateFormatter,
      minWidth: 120,
      flex: 1
    },
    {
      field: 'valid.to',
      type: 'date',
      headerName: t('validTo'),
      valueGetter: (_, row) => nestedFieldValueGetter(row, 'valid.to'),
      valueFormatter: dateFormatter,
      minWidth: 120,
      flex: 1
    }
  ] as GridColDef[];
};
